import React from "react";
import ResponsiveStudentExplanations from "components/students/Explanations/ResponsiveStudentExplanations";
import ResponsiveTeacherExplanations from "components/teachers/Explanations/ResponsiveTeacherExplanations";
import ResponsiveAdminExplanations from "components/adminStartup/Explanations/ResponsiveAdminExplanations";
import RBACSwitcher from "components/common/Auth/RBACSwitcher";

const Explanations = () => {
  return (
    <RBACSwitcher
      admin={<ResponsiveAdminExplanations />}
      student={<ResponsiveStudentExplanations />}
      teacher={<ResponsiveTeacherExplanations />}
      school={<div>Dash Admin écoles - Explications</div>}
      parent={<div>Parent - Explications</div>}
    />
  );
};

export default Explanations;
